import { render, staticRenderFns } from "./AttributeGeneralStats.vue?vue&type=template&id=079ab73a&scoped=true&"
import script from "./AttributeGeneralStats.vue?vue&type=script&lang=js&"
export * from "./AttributeGeneralStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079ab73a",
  null
  
)

export default component.exports